import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../../..';
import { ExportContext } from '../../../../../provider/ExportProvider';

export default function FormLogisticOriginDelete() {
  const { setModal, setInvoice, getInvoice, deleteLogisticOrigins } =
    useContext(ExportContext)!.controllers.logistic;

  const [loading, setLoading] = useState(false);

  const selectedLogisticOrigin = getInvoice('selected.logisticOrigin');
  const selectedLogisticOrigins = getInvoice('selecteds.logisticOrigins');
  const logisticOriginIds =
    selectedLogisticOrigin !== -1 ? [selectedLogisticOrigin] : selectedLogisticOrigins;
  const length = logisticOriginIds.length;

  const close = () => {
    setModal('single.deleteLogisticOrigins', false);
    setInvoice('selected.logisticOrigin', -1);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteLogisticOrigins(logisticOriginIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir o registro?'
            : `Tem certeza que deseja excluir ${length} registros?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
